import React from "react";

const DegreeCertAssist = () => {
  return (
    <div className="birthCertProcedureContainer">
      <h2>
        How Goodway <span>Attestation</span> Can Assist You{" "}
      </h2>
      <p>
        Goodway Attestation is dedicated to providing efficient and reliable
        degree certificate attestation services in Bangalore. Here’s how we can
        assist you:
      </p>
      <ol>
        <li>
          1. <span>Expert Guidance:</span> Our team of experts will guide you
          through the entire attestation process, ensuring you understand each
          step and have all the necessary documents in order.
        </li>
        <li>
          2. <span>Document Verification:</span> We handle the verification of
          your degree certificate from the issuing institution, saving you time
          and effort.
        </li>
        <li>
          3. <span>Efficient Processing:</span> With our extensive experience
          and network, we ensure that your documents are attested promptly
          without unnecessary delays.
        </li>
        <li>
          4. <span>Complete Assistance:</span> From submitting your documents to
          the concerned authorities to obtaining the attestation, we take care
          of everything, providing you with a hassle-free experience.
        </li>

        <li>
          5. <span>Transparent Tracking:</span> We offer a transparent tracking
          system that allows you to monitor the status of your documents
          throughout the attestation process.
        </li>
        <li>
          6. <span>Customer Support:</span> Our dedicated customer support team
          is always available to answer any queries you may have and provide
          regular updates on the progress of your attestation.
        </li>
      </ol>
    </div>
  );
};

export default DegreeCertAssist;
